<template>
    <section class="section link-list primary">
      <div class="link-list-content">
        <div class="content-link create-course">
          <div class="link">
            <a
              class="link-content"
              :class="[isActiveTab(1)? 'active': '']"
              @click="setActiveTab(1)"
            >
              Básico
            </a>
          </div>
          <div class="link">
            <a
              class="link-content"
              :class="[isActiveTab(2)? 'active': '']"
              @click="setActiveTab(2)"
            >
            Layout
            </a>
          </div>
          <div class="link">
            <a
              class="link-content"
              :class="[isActiveTab(3)? 'active': '']"
              @click="setActiveTab(3)"
            >
              Conteúdo
            </a>
          </div>
          <div class="link">
            <a
              class="link-content"
              :class="[isActiveTab(4)? 'active': '']"
              @click="setActiveTab(4)"
            >
              Domínio
            </a>
          </div>
          <div class="link redes-sociais-mobile">
            <a
              class="link-content"
              :class="[isActiveTab(5)? 'active': '']"
              @click="setActiveTab(5)"
            >
              Rede Sociais
            </a>
          </div>
          <div class="link">
            <a
              class="link-content"
              :class="[isActiveTab(6)? 'active': '']"
              @click="setActiveTab(6)"
            >
              Depoimentos
            </a>
          </div>
          <div class="link">
            <a
              class="link-content"
              :class="[isActiveTab(7)? 'active': '']"
              @click="setActiveTab(7)"
            >
              Integrações
            </a>
          </div>
        </div>
      </div>
    </section>

    <section
      class="section config-form primary"
      :class="[isActiveTab(1)? 'active': '']"
    >
      <Config />
    </section>
  
    <section
    class="section config-form primary"
    :class="[isActiveTab(2)? 'active': '']"
  >
    <Layout />
  </section>

    <section
    class="section config-form primary"
    :class="[isActiveTab(3)? 'active': '']"
  >
    <Content />
  </section>

     <section
      class="section config-form primary"
      :class="[isActiveTab(4)? 'active': '']"
    >
    <Domain/>
    </section>

    <section
    class="section config-form primary"
    :class="[isActiveTab(5)? 'active': '']"
  >
  <Social />

  </section>

  <section
  class="section config-form primary"
  :class="[isActiveTab(6)? 'active': '']"
>
<Testimonials  />

</section>


   <section
  class="section config-form primary"
  :class="[isActiveTab(7)? 'active': '']"
>
<Integration />

</section>






  </template>
  
  <script>
    import Config from '@/components/Admin/Site/config'
    import Content from '@/components/Admin/Site/content'
    import Social from '@/components/Admin/Site/social'
    import Testimonials from '@/components/Admin/Site/testimonials'
    import Domain from '@/components/Admin/Site/domain'
    import Layout from '@/components/Admin/Site/layout'
    import Integration from '@/components/Admin/Site/integrations'
    
  export default {
    data() {
      return {
        activeTab: 1,
        hassaved:false,
        openmodalmodule:false,
      }
    },
    props: {
  
    },
    components: {
        Config,
        Content,
        Social,
        Testimonials,
        Domain,
        Layout,
        Integration
    },
    methods: {
      updatevalue(novoValor){
        this.hassaved = novoValor;
      },
  
      setActiveTab(tabNumber) {
        this.activeTab = tabNumber;
      },
      isActiveTab(tabNumber) {
        return this.activeTab === tabNumber;
      },
      openmodal(){
          this.openmodalmodule = !this.openmodalmodule;
      },
        atualizarValorNoFilho(novoValor) {
        this.openmodalmodule = novoValor;
      }
    },
    created() {
  
    }
  }
  </script>
  
  <style scoped>
  .link a {
    display: inline-block;
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    color: rgb(24, 24, 28);
    background-color: rgb(255, 255, 255);
    text-decoration: none;
    padding: 0.5rem 2rem;
    border-bottom: 1px solid rgb(246, 246, 246);
    border-right: 1px solid rgb(246, 246, 246);
    cursor: pointer;
  }
  @media (max-width: 500px) {
    .redes-sociais-mobile {
      min-width: fit-content !important;
    }
  }
  </style>
  